import "./message-sharing.css";
import { withStatics } from '../../utils/with-statics';
import { MessageSharing, OVERLAY_BGCOLOR, CHANNEL_BGCOLOR } from './message-sharing';
import { shareChannelMap } from './message-share-channel';
import { show } from './show';
export default withStatics(MessageSharing, {
  show: show,
  Channel: shareChannelMap,
  OVERLAY_BGCOLOR: OVERLAY_BGCOLOR,
  CHANNEL_BGCOLOR: CHANNEL_BGCOLOR
});